<template lang="pug">
              v-col.pb-8(cols="12" sm="6" md="4")
                v-card.rounded-lg.elevation-25(  style="position: relative")
                    
                    v-list-item.grow
                            v-list-item-avatar(color='grey darken-3')
                                v-img.elevation-6(alt='' src='@/assets/img/social/simplymotion-youtube.png')
                            v-list-item-content
                                v-list-item-title {{ post.platformPostChannelName || $t(`social.platforms.${post.socialConnection.platform}.label`)}}
                            v-list-item-action 
                                v-menu(top='' right='' )
                                    template(v-slot:activator='{ on, attrs }')
                                        v-btn.moreMenu(:disabled="post.status !== SocialPostStatus.TRANSFERED" icon='' v-bind='attrs' v-on='on')
                                            v-icon mdi-dots-vertical
                                    v-card.rounded-lg.elevation-25
                                      v-list-item(@click='refreshPost(post)' dense)
                                        v-list-item-icon.mr-3
                                          v-icon(color="primary") mdi-refresh
                                        v-list-item-title {{$t('social.post.refresh')}}
                    v-divider
                    v-img.primary(:aspect-ratio="16/9" :src='post.platformPostThumbnailUrl')
                    v-card-title {{post.platformPostTitle}}
                    v-card-subtitle.blue-grey--text.lighten-2.caption(v-if="post.postedAt") {{$t('social.post.postedAt', {date: formatDateFromIsoString(post.postedAt)})}} 
                    v-card-text {{post.platformPostDescription}}
                    v-divider
                    v-card-actions.px-4.py-4
                        v-chip.mr-2(flat small)
                            v-icon(left small) visibility
                            span {{ post.platformViewCount || 0 }}
                        v-chip.mr-2(flat small)
                            v-icon(left small) thumb_up_alt
                            span {{ post.platformLikeCount || 0  }}
                        v-chip.mr-2(flat small)
                            v-icon(left small) thumb_down_alt
                            span {{ post.platformDislikeCount || 0  }}
                        v-chip.mr-2(flat small)
                            v-icon(left small) comment
                            span {{ post.platformCommentCount || 0  }}
                    v-divider
                    v-card-actions
                        v-btn(text color="accent" target="_blank" :href="post.platformPostLink" :disabled="!post.platformPostPrivacyStatus") {{$t(`social.platforms.${post.socialConnection.platform}.openOnPlatform`)}}
                        v-spacer
                        v-chip(v-if="post.platformPostPrivacyStatus" small) {{post.platformPostPrivacyStatus}}
                        v-progress-circular(v-else-if="post.status == SocialPostStatus.PROCESSING || post.status == SocialPostStatus.PENDING" indeterminate :width="1" :size="20")
                        v-icon(v-else-if="post.status == SocialPostStatus.FAILED" color="red") unpublished
                        v-chip(v-else small) {{post.status}}

            
</template>

<script>
import urlFormat from "@/utils/urlFormat";
import date from "@/utils/date";
import { SocialPostStatus } from "@/models";

export default {
  name: "PostCard",
  props: ["post"],
  data() {
    return {
      subscription: null,
      SocialPostStatus,
    };
  },
  computed: {},
  watch: {
    post(value) {
      if (
        [SocialPostStatus.PENDING, SocialPostStatus.PROCESSING].includes(
          value.status
        )
      ) {
        this.subscribeToUpdates();
      }
    },
  },
  methods: {
    ...date,
    ...urlFormat,
    refreshPost(post) {
      this.subscribeToUpdates();
      this.$store.dispatch("socialConnection/REFRESH_POST", {
        post,
      });
    },
    async subscribeToUpdates() {
      const subscription = await this.$store.dispatch(
        "socialConnection/LISTEN_TO_POST_UPDATES",
        {
          id: this.post.id,
        }
      );

      this.subscription = subscription;
    },
  },

  beforeDestroy() {
    this.subscription?.unsubscribe();
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables'
</style>
